package com.exura.features.demosets.domain.usecase

import com.exura.features.demosets.domain.DemoSetsConstants
import com.exura.features.demosets.domain.model.ImportDemoSetResponse
import com.exura.features.demosets.domain.model.ImportPrivateDemoSetRequest
import dev.gitlive.firebase.functions.FirebaseFunctions

class ImportPrivateDemoSetUseCase(
    private val functions: FirebaseFunctions,
) {

    suspend operator fun invoke(
        accessCode: String,
    ): Result<List<String>> = runCatching {
        val importCallable = functions.httpsCallable(DemoSetsConstants.Functions.IMPORT_HIDDEN_DEMO_SET)

        val request = ImportPrivateDemoSetRequest(
            accessCode = accessCode,
        )
        println(request)

        val result = importCallable(request)
        println(result.data<String>())
        val response = result.data<ImportDemoSetResponse>()

        if (response.success) {
            response.importedPlanIds.toList()
        } else {
            throw Exception(response.message ?: "Failed to import private demo set")
        }
    }
}
